<template>
  <div class="search-header">
    <div class="form">
      <ul>
        <li v-for="(item, index) in dataMenu" :key="index">
          <router-link :to="item.route">{{ item.title }}</router-link>
        </li>
      </ul>
    </div>
    <div class="close" @click="$emit('on-close')"></div>
  </div>
</template>

<script>
export default {
  name: "Menu",
  props: ["dataMenu"],
  components: {},
  data() {
    return {
      search: "",
    };
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.search-header {
  position: absolute;
  width: initial;
  left: 0px;
  right: 0px;
  z-index: 999;
  background: #f8f7f7;
  transition: all 0.9s ease-in-out;

  .form {
    height: 100%;
    padding: 20px 30px 30px;
    position: relative;
    width: 60%;
    margin: auto;

    @media (min-width: 1661px) {
      width: 30%;
    }
    ul {
      list-style: none;
      display: flex;
      gap: 10px;
      justify-content: space-between;
      text-transform: capitalize;
      font-weight: 400;
      font-size: 1.2rem;
      line-height: 1.45;
      color: #2b938c;
      li {
        a {
          color: #2b938c;
        }
      }
    }
  }
  .close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 32px;
    height: 32px;
    z-index: 999;
    opacity: 0.5;

    &::before,
    &::after {
      position: absolute;
      left: 15px;
      content: " ";
      height: 33px;
      width: 2px;
      background-color: #2b938c;
    }
    &::before {
      transform: rotate(45deg);
    }
    &::after {
      transform: rotate(-45deg);
    }
  }
  .close:hover {
    opacity: 1;
  }
}
</style>